<div class="d-inline-flex justify-content-end w-100">
  @if (displayBackButton) {
    <button class="mwp-button-back me-3" (click)="back()">
      <mwp-text-translate text="Back" jsonKey="back" />
    </button>
  }
  @if (displayCancelButton) {
    <button class="mwp-button-secondary me-3" (click)="cancel()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
  }
  <button class="mwp-button" [disabled]="isContinueDisabled" (click)="complete()">
    <mwp-text-translate text="Confirm" jsonKey="confirm" />
  </button>
</div>